export default function ButtonStyleText({text, disabled=true, className=""}) {
    return (
        <div className={`fango-border-text fango-border${(disabled) ? ' fango-border__greyed' : '' } ${className}`}>
            <span>{text}</span>
        </div>        
    );
}